import { render, staticRenderFns } from "./QuAn.vue?vue&type=template&id=49abb620&"
import script from "./QuAn.vue?vue&type=script&lang=js&"
export * from "./QuAn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports